import type { UsersColumnKey } from "@/modules/users";
import type { FilterDefinition, FilterValue, ToastApi } from "@/ds";
import { createExportFeedback, describeReportFilters, useFileExport } from "@/modules/export";
import { exportUsers } from "@/modules/users";
import type { UsersSort } from "@/modules/users";
import { USERS_EXPORT_FILE_NAME } from "../users.constants";
import type { UsersFilters } from "./use-users-lista";

interface UseUsersExportacaoParams {
  /** Colunas visíveis da tela, na ordem; a exportação leva só elas. */
  readonly colunas: readonly UsersColumnKey[];
  readonly search: string;
  readonly filters: UsersFilters;
  readonly filterValue: FilterValue;
  readonly sort: UsersSort;
  readonly filterColumns: FilterDefinition[];
  /** Listagem vazia: Exportar Visualização avisa "nada a exportar" sem pedir o arquivo. */
  readonly isEmpty: boolean;
  readonly toast: ToastApi;
}

/**
 * Exportar Visualização (HU 1442): o arquivo é gerado pelo servidor com a busca, os filtros e a ordenação em vigor, sem
 * paginação (RN003), e o servidor registra a exportação na auditoria.
 */
export function useUsersExportacao({
  colunas,
  search,
  filters,
  filterValue,
  sort,
  filterColumns,
  isEmpty,
  toast,
}: UseUsersExportacaoParams) {
  return useFileExport({
    fileName: USERS_EXPORT_FILE_NAME,
    loadFile: (format) =>
      exportUsers({
        pesquisa: search,
        time: filters.time,
        papelId: filters.papelId,
        sort,
        filtros: describeReportFilters(search, filterColumns, filterValue),
        colunas,
        format,
      }),
    isEmpty: () => isEmpty,
    ...createExportFeedback(toast),
  });
}
